import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

type Props = {
  isPending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

function Body(): ReactNode {
  return (
    <>
      <p className="text-sm text-text-secondary">
        Se calcularán los pagos pendientes para todos los collectors activos con{' '}
        <strong>$3 o más</strong> acumulados (ya no hay mínimo de $100). Los
        pagos ya <strong>marcados como pagados</strong> no se tocan; cualquier
        pago en estado <strong>pending</strong> se recalcula desde cero.
      </p>
      <p className="mt-sm text-xs text-text-tertiary">
        Puedes pulsar este botón las veces que necesites — es seguro
        re-ejecutarlo después de corregir datos.
      </p>
    </>
  );
}

export function CalculatePaymentsModalContent({
  isPending,
  onConfirm,
  onCancel,
}: Props): ReactNode {
  return (
    <>
      <Body />
      <div className="mt-lg flex justify-end gap-sm">
        <Button variant="ghost" size="sm" onClick={onCancel}>
          Cancelar
        </Button>
        <Button size="sm" onClick={onConfirm} disabled={isPending}>
          {isPending ? 'Calculando…' : 'Calcular pagos'}
        </Button>
      </div>
    </>
  );
}
